<template>
    <div class="a-top">
        <div v-show="selectActivity" class="box" :key="new Date().getMilliseconds()">
            <div class="box3" @click="$emit('clear')">
                <svg viewBox="0 0 40 40">
                    <path class="close-x" d="M 10,10 L 30,30 M 30,10 L 10,30"></path>
                </svg>
            </div>
            <div class="box-overflow">
                <div v-for="(item,index) in selectActivity" :key="index">
                    <img :src="item.img"/>
                    <div class="pic-bottom" @click="selectIndex===index?selectIndex=-1:selectIndex = index"><span>{{item.h4 && item.h4.split(' ')[0]}}</span>&nbsp;&nbsp;&nbsp;&nbsp;活动时间：{{item.period}}</div>
                    <div v-show="selectIndex === index || selectActivity.length == 1">
                        <div class="content">
                            <h3>{{item.h4}}</h3>
                            <div v-html="item.content"></div>
                            <br/>
                            <ul v-if="item.notice">
                                <li v-for="li in item.notice" :key="li" v-html="li"></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            selectIndex: -1,
            rotate:true,
            data1:{
                content:"",
                
            }
        }
    },
    props: ['selectActivity']
}
</script>

<style scoped>
.box{
    position: fixed;
    top: 40%;
    left: 50%;
    margin-left: -305px;
    margin-top: -315px;
    width: 610px;
    background: #fff;
    box-shadow: 0px 0px 3px 2px white;
    border: 1px solid white;
    word-break: break-all;
    z-index: 99999999;
}
.box-overflow{
    max-height: 700px;
    min-height: 630px;
    overflow-y:visible;
    overflow-x: hidden;
}


.box3 {
    right: 130px;
    width: 30px;
    height: 30px;
    -moz-transition: all .5s ease;
    -o-transition: all .5s ease;
    -webkit-transition: all .5s ease;
    transition: all .5s ease;
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 20px;    
}

.rotate{    
    /* animation: changeFontSize 3s ease-in-out 0s infinite; */
}

@keyframes changeFontSize{
    30%{        
        transform: rotate(0deg);
    }    
    60%{        
        transform: rotate(90deg);
    }
  }


.box3:hover {
    -moz-transform: rotate(190deg);
    -ms-transform: rotate(190deg);
    -o-transform: rotate(190deg);
    -webkit-transform: rotate(190deg);
    transform: rotate(190deg);
}

.close-x {
    stroke: #ffff00;
    fill: transparent;
    stroke-linecap: round;
    stroke-width: 5;
}

.pic-bottom{
    background: #ccc;
    color:#fff;
    background: url('../assets/images/Promotion_bar.png') no-repeat;
    background-color: #383431;
    height: 34px;
    line-height: 34px;
    padding-left: 20px;
    background-size: 100%;
    cursor: pointer;
    border-top:1px solid white; 
}

.pic-bottom span{
    color:yellow;
}

h3,
h4,
h5 {
    text-align: center;
}

.box img {
    width: 100%;
    border-top:1px solid white; 
}

.box .content {
    padding: 0px 15px 15px 15px;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 2px;
    /* text-indent: 2em; */
    /* border: 1px solid #ccc; 
    box-shadow: 0 0 3px 0px #383431 inset;
    height: 100%; */
}

.box .content ul{
    text-indent: 2em; 
}

ul{
    list-style-type: none;
}
</style>

<style>

.box .content  table{
    width: 100%;
}
.box .content  table tr{
    border: 1px solid #888686;     
    text-align:center;
}
.box .content  table tr td{
    border: 1px solid #888686; 
    font-size:16px;
    line-height:34px;  
    font-weight:bold;
}
</style>
<style>

.box-overflow span{
    color: #000000;
    font-size: 16px;
}
</style>







// WEBPACK FOOTER //
// src/components/a.header.calander.content.vue